import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Column } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import React from "react";

export const BannerLoadingSkeleton: React.FC = () => {
  return (
    <Column
      style={{
        marginLeft: getSpacing("2x"),
        marginRight: getSpacing("2x"),
      }}
      data-test-id="banner-loading-skeleton"
    >
      <Spacer height="2x" />
      <LoadingSkeleton
        width="100%"
        height={{
          mobileAndAbove: "250px",
          tabletAndAbove: "300px",
          desktopAndAbove: "350px",
        }}
      />
      <Spacer height="2x" />
    </Column>
  );
};
